export default __webpack_public_path__ + "static/media/015.ddc1f8b9.jpg";